let rows = {};
let maxCost;
let maxCostReserve;
let $graphDiv;
let $graphDivBack;
const graphPaddingRL = 5;
$(function () {
    $graphDiv = $('.costgraph');
    $graphDivBack = $('.costgraph_back');
    fillGraphRows();
    setGraphRowsWidth();
    setGraphXAxis();
    setCheckboxHandlers();
    calcResult();
});

function fillGraphRows() {
    let rowsNodes = $('.row', $graphDiv);
    rowsNodes.each(function (i, obj) {
        rows[i] = {
            $element: $(obj),
            cost: parseInt($(obj).data('value')),
            id: $(obj).data('name')
        };
    });
}

function setGraphRowsWidth() {
    maxCost = findMaxRowCost();
    maxCostReserve = maxCost + (maxCost / 100 * (graphPaddingRL * 2));
    Object.values(rows).forEach(function (obj) {
        // noinspection JSPrimitiveTypeWrapperUsage
        obj.widthPercent = obj.cost * 100 / maxCostReserve;
        obj.$element.css({
            width: `${obj.widthPercent}%`,
            'margin-left': `${graphPaddingRL}%`,
        });
    });
}

function setGraphXAxis() {
    const delimCount = 5;
    let perDelimStep = Math.floor(maxCost / (delimCount - 1));
    let perDelimLen = perDelimStep.toString().length - 1;
    perDelimStep = Math.floor(perDelimStep / Math.pow(10, perDelimLen));
    perDelimStep = perDelimStep * Math.pow(10, perDelimLen);

    for (let i = 0; i < delimCount; i++) {
        let perDelim = i * perDelimStep;
        let $div = $(`<div><span>${perDelim}</span></div>`);
        $graphDivBack.append($div);
        if(i === 0) {
            $div.css({
                'margin-left': `${graphPaddingRL}%`
            });
        } else {
            let mleft = perDelim * 100 / maxCostReserve + graphPaddingRL;
            $div.css({
                'margin-left': `${mleft}%`
            });
        }
    }
}

function findMaxRowCost() {
    let row;
    Object.values(rows).forEach(function (obj) {
        if (row === undefined) {
            row = obj;
        } else {
            if (row.cost < obj.cost) {
                row = obj;
            }
        }
    })

    if (row) {
        return row.cost;
    }

    return undefined;
}

function setCheckboxHandlers() {
    Object.values(rows).forEach(function (obj) {
        $(`#${obj.id}`).on('click', function () {
            $(`[data-name=${obj.id}]`).toggleClass('disabled');
            calcResult();
        });
    })
}

function calcResult() {
    let cost = 0;
    Object.values(rows).forEach(function (obj) {
        if(obj.$element.hasClass('disabled') === false) {
            cost += obj.cost;
        }
    });
    $('#cost_price span').text(`${prettyNumber(cost)} ₽`)
}